import type { CameraCalibrationMessage } from './protocol.ts';

let cameraCalibration: CameraCalibrationMessage | undefined;
const calibrationListeners = new Set<(calibration: CameraCalibrationMessage) => void>();

export function setCameraCalibration(calibration: CameraCalibrationMessage): void {
  cameraCalibration = calibration;
  for (const listener of calibrationListeners) listener(calibration);
}

export function getCameraCalibration(): CameraCalibrationMessage | undefined {
  return cameraCalibration;
}

export function onCameraCalibration(listener: (calibration: CameraCalibrationMessage) => void): () => void {
  calibrationListeners.add(listener);
  if (cameraCalibration) listener(cameraCalibration);
  return () => calibrationListeners.delete(listener);
}
